import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { clear } from '../../common/actions/ui';
import Fetcher from '../../common/util/Fetcher';
import PaginatedFetcher from '../../common/util/PaginatedFetcher';
import { setBankFilters, associateEntries, disassociateEntry } from '../../common/actions/banks';
import { handleBankEntryResponse, handleBankEntriesResponse } from '../../common/api/callHandlers';
import { archiveBankEntry } from '../../common/actions/bankEntries';
import { getBank } from './banks';
import { handleError } from '../../common/api/helpers';
import get from 'lodash/get';
import { BANKS_BANK_ENTRY_PAGINATION, GET_BANK_ENTRIES_CALL, GET_BANK_ENTRY_CALL, UPDATE_BANK_ENTRY_CALL, CREATE_BANK_ENTRY_CALL, COPY_BANK_ENTRY_CALL, REMOVE_BANK_ENTRY_CALL } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
export var getBankEntries = function getBankEntries(bankId, useBankSearch) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var page = params.page,
    text = params.text,
    filters = params.filters;
  var basePath = "/api/banks/".concat(bankId, "/bank_entries");
  var searchPath = "".concat(basePath, "/search");
  var interaction_type_ids = get(filters, 'interactionTypes', []);
  var tag_ids = get(filters, 'tags', []);
  var urlParams = {
    page: page,
    text: text,
    interaction_type_ids: interaction_type_ids,
    tag_ids: tag_ids
  };
  return function (dispatch, getState) {
    var getSearchIds = function getSearchIds(json) {
      return json.entries.map(function (e) {
        return e.id;
      });
    };
    var getRecordIds = useBankSearch ? getSearchIds : null;
    var fetcher = new PaginatedFetcher({
      callType: GET_BANK_ENTRIES_CALL,
      onError: handleError(dispatch, t('Failed to fetch bank entries.')),
      getRecordIds: getRecordIds
    });
    var path = useBankSearch ? searchPath : basePath;
    return fetcher.get(path, urlParams).then(function (r) {
      var _ref = useBankSearch ? [r[0].entries, r[1]] : r,
        _ref2 = _slicedToArray(_ref, 2),
        response = _ref2[0],
        pageData = _ref2[1];
      var filterUpdate = [];
      if (useBankSearch) {
        var noInteractions = interaction_type_ids.length === 0;
        var noTags = tag_ids.length === 0;
        if (text === void 0 && noInteractions && noTags) {
          filterUpdate = [setBankFilters(bankId, r[0].filters)];
        }
      }
      dispatch([].concat(_toConsumableArray(filterUpdate), [handleBankEntriesResponse(response), associateEntries(bankId, response.map(function (be) {
        return be.id;
      }))]));
      return pageData;
    });
  };
};
export var getBankEntry = function getBankEntry(bankId, bankEntryId) {
  var url = "/api/banks/".concat(bankId, "/bank_entries/").concat(bankEntryId);
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: GET_BANK_ENTRY_CALL,
      onError: handleError(dispatch, t('Failed to fetch bank entry.'))
    });
    return fetcher.get(url).then(function (response) {
      dispatch(handleBankEntryResponse(response));
      return response;
    });
  };
};
export var cloneBankEntry = function cloneBankEntry(bankEntry, createEntryCb) {
  var updateBankEntryCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : updateBankEntry;
  var entry = bankEntry.getEntry();
  var workingEntry = entry.getWorkingInstance();
  var bankId = bankEntry.bankId;
  return function (dispatch, getState) {
    return dispatch(createEntryCb(workingEntry, bankId, 'bank', entry.id)).then(function (entryData) {
      return dispatch(updateBankEntryCb(bankId, bankEntry.id, {
        entryId: entryData.id
      }));
    });
  };
};
export var createEntryAndBankEntry = function createEntryAndBankEntry(bankId, entry, bankEntry, createEntryCb) {
  var createBankEntryCb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : createBankEntry;
  return function (dispatch, getState) {
    return dispatch(createEntryCb(entry, bankId, 'bank')).then(function (entryData) {
      return dispatch(createBankEntryCb(bankId, bankEntry.entryType, entryData.id));
    });
  };
};
export var moveBankEntryFromQuizEntry = function moveBankEntryFromQuizEntry(sourceQuizId, sourceEntryId, sourceEntryType, destinationBankId) {
  var body = {
    source_entry_id: sourceEntryId,
    source_entry_type: sourceEntryType
  };
  var query_params = {
    source_quiz_id: sourceQuizId
  };
  return copyOrMoveBankEntry(body, destinationBankId, 'move_from_quiz_entry', query_params);
};
export var copyBankEntry = function copyBankEntry(sourceBankId, bankEntryId, destinationBankId) {
  var body = {
    source_bank_id: sourceBankId,
    source_bank_entry_id: bankEntryId
  };
  var followUpActions = [clear("".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(destinationBankId))];
  return copyOrMoveBankEntry(body, destinationBankId, 'copy', null, followUpActions);
};
export var moveBankEntry = function moveBankEntry(sourceBankId, bankEntryId, destinationBankId) {
  var body = {
    source_bank_id: sourceBankId,
    source_bank_entry_id: bankEntryId
  };
  var followUpActions = [clear("".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(destinationBankId)), clear("".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(sourceBankId)), getBank(sourceBankId)];
  return copyOrMoveBankEntry(body, destinationBankId, 'move', null, followUpActions);
};
export var copyOrMoveBankEntry = function copyOrMoveBankEntry(body, destinationBankId, operation, query_params) {
  var followUpActions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var url = "/api/banks/".concat(destinationBankId, "/bank_entries/").concat(operation);
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: COPY_BANK_ENTRY_CALL,
      onError: handleError(dispatch, t('Failed to copy bank entry.'))
    });
    if (query_params) {
      url = fetcher.appendQueryParams(url, query_params);
    }
    return fetcher.post(url, {
      body: JSON.stringify(body)
    }).then(function (response) {
      dispatch([handleBankEntryResponse(response), associateEntries(destinationBankId, [response.id]), getBank(destinationBankId)].concat(_toConsumableArray(followUpActions)));
      return response;
    });
  };
};
export var createBankEntry = function createBankEntry(bankId, entryType, entryId) {
  var url = "/api/banks/".concat(bankId, "/bank_entries");
  return function (dispatch, getState) {
    var newBankEntryData = JSON.stringify({
      bank_entry: {
        bank_id: bankId,
        entry_type: entryType,
        entry_id: entryId
      }
    });
    var fetcher = new Fetcher({
      callType: CREATE_BANK_ENTRY_CALL,
      onError: handleError(dispatch, t('Failed to create bank entry.'))
    });
    return fetcher.post(url, {
      body: newBankEntryData
    }).then(function (response) {
      dispatch([handleBankEntryResponse(response), associateEntries(bankId, [response.id]), clear("".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(bankId)), getBank(bankId)]);
      return response;
    });
  };
};
export var updateBankEntry = function updateBankEntry(bankId, bankEntryId, params) {
  var url = "/api/banks/".concat(bankId, "/bank_entries/").concat(bankEntryId);
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: UPDATE_BANK_ENTRY_CALL,
      onError: handleError(dispatch, t('Failed to update bank entry.'))
    });
    var reqParams = {
      bank_id: params.bankId,
      entry_id: params.entryId
    };
    var updateBankEntryParams = {
      body: JSON.stringify({
        bank_entry: reqParams
      })
    };
    return fetcher.patch(url, updateBankEntryParams).then(function (response) {
      dispatch([handleBankEntryResponse(response), associateEntries(response.bank_id, [response.id])]);
      if (params.bankId && bankId !== params.bankId) {
        dispatch([clear("".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(bankId)), clear("".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(params.bankId)), getBank(bankId), getBank(params.bankId)]);
      }
      return response;
    });
  };
};
export var removeBankEntry = function removeBankEntry(bankId, bankEntryId) {
  var url = "/api/banks/".concat(bankId, "/bank_entries/").concat(bankEntryId);
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: REMOVE_BANK_ENTRY_CALL,
      onError: handleError(dispatch, t('Failed to remove bank entry.'))
    });
    return fetcher["delete"](url).then(function (response) {
      return dispatch([disassociateEntry(bankId, bankEntryId), clear("".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(bankId)), getBank(bankId), archiveBankEntry(bankEntryId)]);
    });
  };
};